<template>
	<div id="set_password" class="login">
		<div class="user-login-5">
            <div class="row bs-reset">
            	<div class="col-md-6 bs-reset mt-login-5-bsfix">
                    <div class="login-bg">
                        <img class="login-logo" src="../assets/img/app/logo.png" />
                    </div>
                </div>
                <div class="col-md-6 login-container bs-reset mt-login-5-bsfix">
                    <div class="login-content" v-if="currentView === 'expired_token'">
						<h1>This token is expired.</h1>
						<button class="btn green" @click="routeToLogin()">Return to Login</button>
					</div>
                    <div class="login-content" v-if="currentView === 'set_password_form'">
                    	<h1>Set UNOapp Password</h1>
                    	<p class="margin-10">Enter your desired password in the fields below.</p>
						<p class="margin-10">Please note that you may only use a secure strengthened password.</p>
						<p class="margin-10">It is best to use at least 10 characters, and to avoid using dictionary words.</p>
                    	<form class="login-form" @submit.prevent="setPassword($event)">
                            <div class="alert alert-danger" v-if="errorMessage.length">
                                <button class="close" data-close="alert" @click="clearError()"></button>
                                <span>{{ errorMessage }}</span>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input class="form-control form-control-solid placeholder-no-fix form-group" type="password" autocomplete="off" placeholder="Password" name="password" v-model="password"/> 
                                    <div class="password-approval-blocks" v-if="strength.length" :class="{'very-weak': strength === 'Very Weak' || strength == 'Password must be 8 characters minimum', 'weak': strength === 'Weak', 'ok': strength === 'OK', 'strong': strength === 'Strong'}">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
									<div class="password-approval-text" v-if="strength.length" :class="{'very-weak': strength === 'Very Weak' || strength == 'Password must be 8 characters minimum', 'weak': strength === 'Weak', 'ok': strength === 'OK', 'strong': strength === 'Strong'}">{{ strength }}</div>
                               	</div>
                                <div class="col-sm-6">
                                    <input class="form-control form-control-solid placeholder-no-fix form-group" type="password" autocomplete="off" placeholder="Confirm Password" name="confirm_password"  v-model="confirmPassword"/> 
                                    <div class="password-approval-text very-weak" v-if="confirmPassword.length && !passwordsMatch">Passwords do not match</div>
									<div class="password-approval-text strong" v-if="confirmPassword.length && passwordsMatch">Passwords match</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 text-right">
                                    <button class="btn green" type="submit">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="login-content" v-if="currentView === 'password_success'">
						<h1>Your password was set successfully!</h1>
                        <button class="btn green" @click="routeToLogin()">Login to UNOapp</button>
					</div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
const img1 = require('../assets/img/app/login/bg1.jpg')
const img2 = require('../assets/img/app/login/bg2.jpg')
const img3 = require('../assets/img/app/login/bg3.jpg')

/**
 * Set Password module is a page where the password of a user can be set or reset.
 * @class SetPassword
 * @since 0.0.1
 */

import $ from 'jquery'
import GlobalFunctions from '../global'
import {BackgroundRotator} from '../assets/scripts/backgroundRotator'
import Auth from '../controllers/Auth'

let invitationToken

let userIsStaff = false

/**
 * To check if the user who is setting up the password is UNOapp staff.
 * @function
 * @param {string} email - The users email address.
 * @returns {undefined}
 * @memberof SetPassword
 * @version 0.0.4
 */
let checkIfStaffPassword = email => {
	if (email.indexOf('@unoapp.com') !== -1) {
		userIsStaff = true
	}
}

/**
 * To check if the password and confirmation match.
 * @function
 * @param {string} password - The password to be checked.
 * @param {string} confirmPassword - The confirmation to be checked.
 * @returns {boolean} Whether or not the passwords match
 * @memberof SetPassword
 * @version 0.0.4
 */
let checkMatchingPasswords = (password, confirmPassword) => {
	if (password === confirmPassword) {
		return true
	} else {
		return false
	}
}

export default {
	name: 'set-password',
	data () {
		return {
			password: '',
			confirmPassword: '',
			strength: '',
			passwordsMatch: false,
			errorMessage: '',
			currentView: ''
		}
	},
	/**
	 * Run on `created` to check whether or not the user has an expired invitation token.
	 * @function
	 * @returns {undefined}
	 * @memberof SetPassword
	 * @version 0.0.4
	 */
	created () {
		let _this = this

		if (_this.$route) {
			invitationToken = _this.$route.params.invitation_token
		}

		if (!invitationToken || !invitationToken.length) {
			this.currentView = 'expired_token'
		} else {
			Auth.checkInvitationTokenExpiry(invitationToken).then(response => {
				_this.currentView = 'set_password_form'
				checkIfStaffPassword(response.payload.email)
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'token_invalid':
						_this.currentView = 'expired_token'
						break

					case 'token_expired':
						_this.currentView = 'expired_token'
						break

					default:
						// No default
					}
				}
			}))
		}
	},
	/**
	 * Run on `mounted` to initialize the background rotator.
	 * @function
	 * @returns {undefined}
	 * @memberof SetPassword
	 * @version 0.0.4
	 */
	mounted () {
		$('body').removeClass()

		let elm = $('.login-bg')
		let images = [
			img1,
			img2,
			img3
		]

		let options = {fade: 1000, duration: 6000}

		BackgroundRotator(elm, images, options).init()
	},
	methods: {
		/**
		 * To clear an error message.
		 * @function
		 * @returns {undefined}
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To check if the password data is valid before making a backend call.
		 * @function
		 * @returns {object} A promise that will reject an invalid password
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		validatePasswordData () {
			let _this = this
			return new Promise((resolve, reject) => {
				if (!_this.password.length) {
					reject('Your password cannot be blank')
				} else if (_this.password.length < 8) {
					reject('Your password must be 8 characters minimum')
				} else if (_this.strength === 'Very Weak') {
					reject('Your password needs to be stronger')
				} else if (_this.strength === 'Weak' && userIsStaff) {
					reject('Your password needs to be stronger')
				} else if (!_this.passwordsMatch) {
					reject('Your passwords don\'t match')
				}
				resolve('Hurray')
			})
		},
		/**
		 * To prompt the backend call that sets the password.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		setPassword (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.clearError()
			return _this.validatePasswordData()
			.then(response => {
				Auth.setPassword(invitationToken, _this.password).then(response => {
					this.currentView = 'password_success'
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'weak_password':
							_this.errorMessage = 'Your password needs to be stronger'
							break

						case 'token_invalid':
							_this.currentView = 'expired_token'
							break

						case 'token_expired':
							_this.currentView = 'expired_token'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To reroute to the login screen.
		 * @function
		 * @returns {undefined}
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		routeToLogin () {
			this.$router.push('/login')
		}
	},
	watch: {
		/**
		 * To watch the password variable and check the strength on change.
		 * @function
		 * @returns {undefined}
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		password () {
			if (this.password.length === 0) {
				this.strength = ''
				return
			}

			this.strength = GlobalFunctions.passwordStrengthCheck(this.password)

			if (this.confirmPassword.length) {
				this.passwordsMatch = checkMatchingPasswords(this.password, this.confirmPassword)
			}
		},
		/**
		 * To watch the confirmPassword variable and check if it matches the password on change.
		 * @function
		 * @returns {undefined}
		 * @memberof SetPassword
		 * @version 0.0.4
		 */
		confirmPassword () {
			if (this.confirmPassword.length) {
				this.passwordsMatch = checkMatchingPasswords(this.password, this.confirmPassword)
			}
		}
	}
}
</script>

<style>
	.login-bg {
  		background-image: url('~src/assets/img/app/login/bg1.jpg');
	}
</style>


// WEBPACK FOOTER //
// SetPassword.vue?757c0d1a